import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"
import PageNavBar from "@components/PageNavBar"
import SiteLogo from "@images/logo.png"
import styles from "./PageFooter.module.scss"

const PageFooter = ({ siteTitle }) => (
  <footer
    style={{
      background: `rebeccapurple`,
      width: `100%`,
      position: `absolute`,
      bottom: `0`,

    }}
  >
    <div
      style={{
        margin: `0 auto`,
      }}
      className={ styles.footerParent }
    >
      <div className={styles.headerLogoSection}>
        <h1 style={{ margin: 0 }}>
          <Link
            to="/"
            style={{
              color: `white`,
              textDecoration: `none`,
            }}
          >
            <img alt={"HyperSocio"} className={ styles.headerLogo } src={SiteLogo} />
          </Link>
        </h1>
      </div>
      <div className={styles.headerMenuSection}>
        <PageNavBar />
      </div>
    </div>
  </footer>
)

PageFooter.propTypes = {
  siteTitle: PropTypes.string,
}

PageFooter.defaultProps = {
  siteTitle: ``,
}

export default PageFooter
